import TourGamesWelcomeView from './TourGamesWelcomeView';
export default TourGamesWelcomeView;
